import SCHEDULING_GROUP_NAME_ERROR_ACTIONS from './SchedulingGroupNameErrorActions';

export const showSchedulingGroupNameError = () => ({
  type: SCHEDULING_GROUP_NAME_ERROR_ACTIONS.showSchedulingGroupNameError,
});

export const hideSchedulingGroupNameError = () => ({
  type: SCHEDULING_GROUP_NAME_ERROR_ACTIONS.hideSchedulingGroupNameError,
});
